// extracted by mini-css-extract-plugin
export default {"subsection":"privacyPolicy_subsection__329IW","section":"privacyPolicy_section__efGN+","heading":"privacyPolicy_heading__r4U-X","main":"privacyPolicy_main__zPWfF"};